import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const imageV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Image element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'image'>): void => {
    const imageProps = props;

    if (imageProps?.style?.general?.title && !imageProps?.content?.title?.iconColor) {
      const currentColor = imageProps.style.general.title.color1;
      imageProps.content = {
        ...imageProps.content,
        title: {
          ...imageProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
